import { useElement, useLocale } from "../../../hooks";
import { useSubscriptionForm } from "./hooks";
import "./style.scss";

export const SubscriptionForm = () => {
  const { t } = useLocale();
  const Input = useElement("Input");
  const Button = useElement("Button");
  const { value, setvalue, subscribeForFranchise } = useSubscriptionForm();
  return (
    <form
      className="subscription-form form-inline"
      onSubmit={subscribeForFranchise}
      noValidate
    >
      <Input
        placeholder={t("placeholder.email")}
        value={value}
        onChange={(e) => setvalue(e.target.value)}
        required
      />
      <Button type="submit" className="btn btn-primary">
        {t("becomePartnerCTA")}
      </Button>
    </form>
  );
};
